import { Key } from 'react';

import { dpr } from 'Utils/dpr';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

import { IProductListCreativeItem } from 'Types/Litium';
import Markup from 'Components/Markup';
import { ISrcSetSize } from 'Components/ProductCard/ProductCardImage';

interface ProductListCreativeItem extends IProductListCreativeItem {
    item: IProductListCreativeItem;
    srcSetSizes?: ISrcSetSize;
}

const productListCreativeItem = ({
    item,
    srcSetSizes = {
        default: { height: 228, width: 350 },
        md: { height: 509, width: 732 },
        lg: { height: 305, width: 444 },
        xl: {
            height: 664,
            width: 950,
        },
        xxl: {
            height: 664,
            width: 950,
        },
    },
}: ProductListCreativeItem) => {
    const sizes = (
        Object.entries(srcSetSizes) as SizeEntries<typeof srcSetSizes>
    )
        .map(([key, value]) => ({
            breakPointVal: parseInt(tailwindBreakpoints[key] as string),
            key,
            width: value.width,
            srcWidth: value.width,
            height: value.height,
            srcHeight: value.height,
        }))
        .filter((x: { key: string | number }) => tailwindBreakpoints[x.key])
        .sort(
            (a: { breakPointVal: number }, b: { breakPointVal: number }) =>
                b.breakPointVal - a.breakPointVal
        );

    return (
        <div className="relative mb-2 flex w-full flex-col gap-3 supports-[grid-template-rows:_subgrid]:contents">
            <a href={item.linkUrl}>
                <picture className="">
                    {sizes.map(
                        (value: {
                            key: Key;
                            width: string | number;
                            height: string | number;
                            srcHeight: any;
                            srcWidth: any;
                        }) => (
                            <source
                                key={value.key}
                                width={value.width}
                                height={value.height}
                                media={`(min-width: ${
                                    tailwindBreakpoints[value.key]
                                })`}
                                srcSet={dpr(
                                    `${item.image.src}?format=webp&fit=crop&height=${value.srcHeight}&width=${value.srcWidth}`
                                )}
                            />
                        )
                    )}
                    <img
                        className="h-full w-full object-cover"
                        src={`${item.image.src}?format=webp&fit=crop&height=auto&width=auto`}
                        srcSet={dpr(
                            `${item.image.src}?format=webp&fit=crop&height=auto&width=auto`
                        )}
                        alt={item.image.altText}
                        loading="lazy"
                    />
                </picture>
            </a>
            {item.text?.value && (
                <Markup
                    html={item.text.value}
                    cssClass="prose-block leading-4 mb-0 font-light bottom-8 px-1.5 lg:pb-2 lg:px-3"
                />
            )}
        </div>
    );
};

export default productListCreativeItem;
